import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import ForgotPasswordModal from "./ForgotPasswordModal";
import "./LoginModal.css";
import discordIcon from "../assets/discord-login.png";
import googleIcon from "../assets/google-login.png";

const LoginModal = ({ onLogin, onClose }) => {
  const [email, setEmail] = useState(
    window.defaultLoginCredentials?.email || ""
  );
  const [password, setPassword] = useState(
    window.defaultLoginCredentials?.password || ""
  );
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      window.defaultLoginCredentials = null;
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseUrl}/users/login`,
        { email, password },
        { withCredentials: true }
      );

      // Pass token/userId/role to parent
      onLogin({
        token: response.data?.accessToken,
        userId: response.data?.userId,
        role: response.data?.role,
      });

      // Do NOT navigate — let parent control flow
    } catch (error) {
      console.error("Error during login:", error);
      if (error.response?.status === 401) {
        setLoginError("Incorrect username or password.");
      } else {
        setLoginError("Incorrect username or password");
      }
    }
  };

  const handleOutsideClick = (e) => {
    if (e.target.className === "login-modal-wrapper") {
      onClose();
    }
  };

  const handleRegisterClick = () => {
    navigate("/register");
    onClose();
  };

  return (
    <div className="login-modal-wrapper" onClick={handleOutsideClick}>
      <div className="login-modal">
        <button className="login-modal-close" onClick={onClose}>
          x
        </button>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {loginError && (
            <div
              style={{ color: "red", marginTop: "10px", fontSize: "0.85rem" }}
            >
              {loginError}
            </div>
          )}

          <button type="submit" className="login-submit-button">
            Login
          </button>
        </form>
        <p className="or-text">OR</p>

        {/* OAuth buttons here if needed */}
        {/* 
        <div className="oauth-buttons">
          <a
            href={
              process.env.REACT_APP_GOOGLE_OAUTH_URL ||
              "https://leetcodehelper-backend.onrender.com/users/auth/google"
            }
            className="oauth-button google-button"
          >
            <img src={googleIcon} alt="Google" className="oauth-icon" />
            Login with Google
          </a>
          <a
            href={
              process.env.REACT_APP_DISCORD_OAUTH_URL ||
              "https://leetcodehelper-backend.onrender.com/users/auth/discord"
            }
            className="oauth-button discord-button"
          >
            <img src={discordIcon} alt="Discord" className="oauth-icon" />
            Login with Discord
          </a>
        </div>
        */}

        <Link
          to="/register"
          className="register-button"
          onClick={handleRegisterClick}
        >
          Create Account
        </Link>
        <button
          className="forgot-password-button"
          onClick={() => setShowForgotPasswordModal(true)}
        >
          Forgot Password?
        </button>
        {showForgotPasswordModal && (
          <ForgotPasswordModal
            onClose={() => setShowForgotPasswordModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default LoginModal;
